import {SET_PATTERN_TO_EDIT_COLOR} from 'constants/action-types.js';
import {DOT, DASH, VARIABLE} from 'effects/midi/tidal/types.js';
import {SET_PATTERN_COLOR} from 'constants/action-types.js';
import {SET_JAKI_GRID_MODE} from 'constants/action-types.js';
import {SET_SHOW_SAVE_MODAL} from 'constants/action-types.js';

let initialState = {
    patternToEditColor: undefined,
    patternColors: {}, 
    jakiGridMode: DASH,
    showSaveModal: false,
};

const toolbarReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_SHOW_SAVE_MODAL:
        return {... state, showSaveModal: action.payload};
    case SET_JAKI_GRID_MODE:
        return {... state, jakiGridMode: action.payload};
    case SET_PATTERN_TO_EDIT_COLOR:
        return {...state, patternToEditColor: action.payload};
    case SET_PATTERN_COLOR:
        let patternColors = {...state.patternColors};
        patternColors[action.payload.pattern] = action.payload.color;
        return {...state, patternColors: patternColors};
    default:
        return state;
    }
}

export default toolbarReducer;
